import { PageNotFoundComponent } from '../not-found.component';
import { LayoutComponent } from '../layout/layout.component';
import { TestComponent } from '../test/test.component';
import { NotificationService } from '../service/notification.service';
import { LocalStorageService } from '../service/local-storage.service';
import { ImgSrcDirective } from '../directives/imgSrc.directive';
import { BAuthGuard } from '../service/bAuthGuard.service';
import { BAppService } from '../service/bApp.service';
import { BLocalStorageService } from '../service/bLocalStorage.service';
import { BSessionStorage } from '../service/bSessionStorage.service';
import { BLoginService } from '../service/bLogin.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BHttp } from '../service/bHTTP';
import { BHTTPLoader } from '../service/bHTTPLoader';
import { PubSubService } from '../service/pubSub.service';
import { AlertComponent } from '../alertComponent/alert.component';
import { BDataSourceService } from '../service/bDataSource.service';
import { bhiveMapComponent } from '../mapComponent/map.component';
import { APP_INITIALIZER } from '@angular/core';
import { BLogoutService } from '../service/bLogout.service';

//CORE_REFERENCE_IMPORTS
//CORE_REFERENCE_IMPORT-wicService
import { wicService } from '../services/wic/wic.service';
//CORE_REFERENCE_IMPORT-utilityService
import { utilityService } from '../services/utility/utility.service';
//CORE_REFERENCE_IMPORT-socialService
import { socialService } from '../services/social/social.service';
//CORE_REFERENCE_IMPORT-loginguardService
import { logingaurdService } from '../services/loginGaurd/logingaurd.service';
//CORE_REFERENCE_IMPORT-iccService
import { iccService } from '../services/icc/icc.service';
//CORE_REFERENCE_IMPORT-homedashService
import { homedashService } from '../services/homeDash/homedash.service';
//CORE_REFERENCE_IMPORT-dashboardresolveService
import { dashboardresolveService } from '../services/dashboardresolve/dashboardresolve.service';
//CORE_REFERENCE_IMPORT-dashboardService
import { dashboardService } from '../services/dashboard/dashboard.service';
//CORE_REFERENCE_IMPORT-inboundcallcenterComponent
import { inboundcallcenterComponent } from '../inboundcallcenterComponent/inboundcallcenter.component';
//CORE_REFERENCE_IMPORT-layoutpageComponent
import { layoutpageComponent } from '../layoutpageComponent/layoutpage.component';
//CORE_REFERENCE_IMPORT-loginComponent
import { loginComponent } from '../loginComponent/login.component';
//CORE_REFERENCE_IMPORT-productsComponent
import { productsComponent } from '../productsComponent/products.component';
//CORE_REFERENCE_IMPORT-notificationComponent
import { notificationComponent } from '../notificationComponent/notification.component';
//CORE_REFERENCE_IMPORT-vschartsComponent
import { vschartsComponent } from '../vschartsComponent/vscharts.component';
//CORE_REFERENCE_IMPORT-socialComponent
import { socialComponent } from '../socialComponent/social.component';
//CORE_REFERENCE_IMPORT-ccComponent
import { ccComponent } from '../ccComponent/cc.component';
//CORE_REFERENCE_IMPORT-missioncontrolComponent
import { missioncontrolComponent } from '../missioncontrolComponent/missioncontrol.component';
//CORE_REFERENCE_IMPORT-homepageComponent
import { homepageComponent } from '../homepageComponent/homepage.component';
//CORE_REFERENCE_IMPORT-spinnerComponent
import { spinnerComponent } from '../spinnerComponent/spinner.component';
//CORE_REFERENCE_IMPORT-wiccardviewComponent
import { wiccardviewComponent } from '../wiccardviewComponent/wiccardview.component';
//CORE_REFERENCE_IMPORT-walkincenterComponent
import { walkincenterComponent } from '../walkincenterComponent/walkincenter.component';

export function startupServiceFactory(startupService: BLocalStorageService): Function {
  return () => startupService.initStorage();
}


/**
*bootstrap for @NgModule
*/
export const appBootstrap: any = [
  LayoutComponent,
];

/**
*Entry Components for @NgModule
*/
export const appEntryComponents: any = [
  AlertComponent
  //CORE_REFERENCE_PUSH_TO_ENTRY_ARRAY
];

/**
*declarations for @NgModule
*/
export const appDeclarations = [
  ImgSrcDirective,
  LayoutComponent,
  TestComponent,
  AlertComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-loginComponent
loginComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-homepageComponent
homepageComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-missioncontrolComponent
missioncontrolComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-vschartsComponent
vschartsComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-notificationComponent
notificationComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-layoutpageComponent
layoutpageComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-inboundcallcenterComponent
inboundcallcenterComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-productsComponent
productsComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-homepageComponent
homepageComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-spinnerComponent
spinnerComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-wiccardviewComponent
wiccardviewComponent,
//CORE_REFERENCE_PUSH_TO_DEC_ARRAY-walkincenterComponent
walkincenterComponent,
    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-iccComponent
    inboundcallcenterComponent,
    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-layoutpageComponent
    layoutpageComponent,
    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-loginComponent
    loginComponent,
    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-productsComponent
    productsComponent,
    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-notificationComponent
    notificationComponent,
    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-vschartsComponent
    vschartsComponent,
    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-socialComponent
    socialComponent,
    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-wicComponent

    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-ccComponent
    ccComponent,
    //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-missioncontrolComponent
    missioncontrolComponent,
  PageNotFoundComponent,
  bhiveMapComponent
];

/**
* provider for @NgModuke
*/
export const appProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: BHttp,
    multi: true
  },
  {
    // Provider for APP_INITIALIZER
    provide: APP_INITIALIZER,
    useFactory: startupServiceFactory,
    deps: [BLocalStorageService],
    multi: true
  },
  NotificationService,
  BAuthGuard,
  //CORE_REFERENCE_PUSH_TO_PRO_ARRAY
//CORE_REFERENCE_PUSH_TO_PRO_ARRAY-wicService
wicService,
//CORE_REFERENCE_PUSH_TO_PRO_ARRAY-utilityService
utilityService,
//CORE_REFERENCE_PUSH_TO_PRO_ARRAY-socialService
socialService,
//CORE_REFERENCE_PUSH_TO_PRO_ARRAY-loginguardService
logingaurdService,
//CORE_REFERENCE_PUSH_TO_PRO_ARRAY-iccService
iccService,
//CORE_REFERENCE_PUSH_TO_PRO_ARRAY-homedashService
homedashService,
//CORE_REFERENCE_PUSH_TO_PRO_ARRAY-dashboardresolveService
dashboardresolveService,
//CORE_REFERENCE_PUSH_TO_PRO_ARRAY-dashboardService
dashboardService,
  LocalStorageService,
  PubSubService,
  BLoginService,
  BSessionStorage,
  BLocalStorageService,
  BAppService,
  BLogoutService,
  BHTTPLoader,
  BDataSourceService

];

/**
* Routes available for bApp
*/

// CORE_REFERENCE_PUSH_TO_ROUTE_ARRAY_START
export const appRoutes = [{path: 'bhive', component: layoutpageComponent, resolve: {'dashboard': dashboardresolveService}, canActivate: [BAuthGuard],
children: [{path: '', component: homepageComponent},{path: 'walkincenter', component: walkincenterComponent},{path: 'social', component: socialComponent},{path: 'notification', component: notificationComponent},{path: 'inbound-call-center', component: inboundcallcenterComponent}]},{path: 'login', component: loginComponent},{path: 'unauthorized', redirectTo: '/login', pathMatch: 'full'},{path: '', redirectTo: '/bhive', pathMatch: 'full'},{path: '**', component: PageNotFoundComponent}]
// CORE_REFERENCE_PUSH_TO_ROUTE_ARRAY_END


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/config/declarations.ts